import * as Sentry from '@sentry/gatsby';
import { sentryConfigActivationAffiliateClub } from '@agria/utils/src/sentryConfigActivationAffiliateClub';

Sentry.init(sentryConfigActivationAffiliateClub);
